import { axios } from '@Root/API'

export const postLeavers = payload => {
  return axios.post(`students/rollover-leaver`, payload)
}
